const preloader = document.getElementById('preloader');
if (preloader) {
  // Immediately remove pointer-events so the preloader never blocks the LCP image
  preloader.style.pointerEvents = 'none';

  const duration = Math.max(0, parseFloat(preloader.dataset.duration) || 0) * 1000;

  function fadeOutPreloader() {
    // 400ms transition instead of 1000ms — reduces the visibility window by 600ms
    preloader.style.transition = 'opacity 0.4s ease';
    preloader.style.opacity = '0';
    setTimeout(() => {
      preloader.style.visibility = 'hidden';
      preloader.style.display = 'none';
    }, 400);
  }

  // DOMContentLoaded fires as soon as HTML is parsed — much earlier than window.load
  // (window.load waits for every image, font, and script to finish, adding 1-3s of delay)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(fadeOutPreloader, duration);
    });
  } else {
    // DOMContentLoaded already fired (inline script or deferred execution)
    setTimeout(fadeOutPreloader, duration);
  }
}
